import { Box, Typography } from '@mui/material';
import React from 'react';
import { LightBulbIcon } from '../../../icons';
import { useTranslation } from 'react-i18next';

type Props = {
  title?: string;
  description: string | string[];
};

export const HintBox: React.FC<Props> = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <Box className="bg-info-lightest p-4 rounded-xl">
      <div className="flex flex-row gap-x-2 pb-2">
        <LightBulbIcon width={20} height={20} />
        <Typography className="font-bold">{title ?? t('bonus:hintTitle')}</Typography>
      </div>
      <Typography className="text-sm italic">{description}</Typography>
    </Box>
  );
};
